import React, { useState } from "react";
import WC from "../../../../../reusable/wordcloud";
import { useSelector, useDispatch } from "react-redux";
import {
  selectWordCloud,
  showTopicData,
  selectHiddenKeywords,
  selectCompareWordCloud,
  selectCompareHiddenKeywords,
} from "../../../../../../app/store/overviewSlice";
import { Word } from "react-wordcloud";
import styles from "./wordcloud.module.scss";
import {
  selectCompareFeedTaskInfo,
  selectCompareTaskId,
  selectFeedTaskInfo,
  selectTaskId,
} from "../../../../../../app/store/feedSlice";
import KeywordManager from "./KeywordManager/KeywordManager";
import EmptyStatePlaceholder from "../../components/EmptyStatePlaceholder";
import WordCloudSkeleton from "./Skeleton";
import { GadgetBody, GadgetHeader, GadgetRoot } from "../../styled";
import { TaskInfo } from "../../../../../../app/interfaces/feed";

const WordCloud = () => {
  const dispatch = useDispatch();

  const [showDropdown, setShowDropdown] = useState(false);
  const [showManager, setShowManager] = useState(false);

  const topWords = useSelector(selectWordCloud);
  const compareTopWords = useSelector(selectCompareWordCloud);
  const taskId = useSelector(selectTaskId);
  const compareTaskId = useSelector(selectCompareTaskId);
  const hiddenKeywords = useSelector(selectHiddenKeywords);
  const compareHiddenKeywords = useSelector(selectCompareHiddenKeywords);

  const compareTask = useSelector(selectCompareFeedTaskInfo);
  const task: TaskInfo = useSelector(selectFeedTaskInfo);

  const wcdata: Word[] | null = topWords
    ? topWords
        .filter((item) => !hiddenKeywords?.includes(item.word))
        .map((t) => ({ text: t.word, value: t.count }))
    : null;

  const compareWcData: Word[] | null = compareTopWords
    ? compareTopWords
        .filter((item) => !compareHiddenKeywords?.includes(item.word))
        .map((t) => ({ text: t.word, value: t.count }))
    : null;

  const onClickWord = (word: string) => {
    dispatch(
      showTopicData({
        topics: [word],
        taskId,
      })
    );
  };

  const onClickCompareWord = (word: string) => {
    dispatch(
      showTopicData({
        topics: [word],
        taskId: compareTaskId,
      })
    );
  };
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (!showDropdown) {
      document.addEventListener("click", closeMenu);
    }
    setShowDropdown(true);
    event.stopPropagation();
  };

  const closeMenu = () => {
    setShowDropdown(false);
    document.removeEventListener("click", closeMenu);
  };

  const openKeywordManager = () => {
    setShowManager(true);
    setShowDropdown(false);
  };

  return (
    <GadgetRoot>
      <GadgetHeader>
        <h3>Intelligent Word Cloud</h3>
        {topWords?.length !== 0 && (
          <div className={styles.dropdownContainer}>
            <button onClick={handleClick}>
              <i className="fas fa-ellipsis-v" />
            </button>
            {showDropdown && (
              <div className={styles.dropdownMenu}>
                <div
                  className={styles.dropdownItem}
                  onClick={openKeywordManager}
                >
                  <div className={styles.dropdownItemContent}>
                    <img
                      className={styles.dropdownItemContentIcon}
                      src="https://d18dyb0v4b4cx9.cloudfront.net/edit_hidden_list.svg"
                      alt="edit hidden words"
                    />
                    <p>Manage hidden keywords</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </GadgetHeader>
      <div style={{ display: "flex" }}>
        <div style={{ flex: "1 1 " }}>
          <div
            style={{
              marginLeft: "40px",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#29d1d7",
              fontWeight: "bold",
            }}
          >
            {task?.task_name}
          </div>
          <GadgetBody>
            {wcdata ? (
              wcdata.length ? (
                <WC words={wcdata} onClickWord={onClickWord} color="#29d1d7" />
              ) : (
                <EmptyStatePlaceholder />
              )
            ) : (
              <WordCloudSkeleton />
            )}
          </GadgetBody>
        </div>

        <div style={{ flex: "1 1 " }}>
          <div
            style={{
              marginLeft: "40px",
              marginTop: "10px",
              marginBottom: "10px",
              color: "#ffd45d",
              fontWeight: "bold",
            }}
          >
            {compareTask?.task_name}
          </div>
          <GadgetBody>
            {compareWcData ? (
              compareWcData.length ? (
                <WC
                  words={compareWcData}
                  onClickWord={onClickCompareWord}
                  color="#ffd45d"
                />
              ) : (
                <EmptyStatePlaceholder />
              )
            ) : (
              <WordCloudSkeleton />
            )}
          </GadgetBody>
        </div>
      </div>

      {showManager && (
        <KeywordManager
          words={topWords ?? []}
          hidden={hiddenKeywords}
          cancel={() => {
            setShowManager(false);
          }}
        />
      )}
    </GadgetRoot>
  );
};

export default WordCloud;
